/* eslint-disable */
import React from 'react';
// 总部
const headquarters = 'https://www.amap.com/search?query=%E5%8D%97%E4%BA%AC%E5%B8%82%E9%BC%93%E6%A5%BC%E5%8C%BA%E4%B8%AD%E5%B1%B1%E5%8C%97%E8%B7%AF550%E5%8F%B7&city=320100&geoobj=118.736095%7C32.085814%7C118.743854%7C32.089269&zoom=18';

const xining = "https://gaode.com/search?query=%E8%A5%BF%E5%AE%81%E5%B8%82%E5%9F%8E%E4%B8%9C%E5%8C%BA%E5%85%B1%E5%92%8C%E8%B7%AF56%E5%8F%B7&city=630100&geoobj=101.799828%7C36.615995%7C101.807587%7C36.619267&zoom=18"
export const Contact00DataSource = {
    wrapper: {className: 'home-page-wrapper content10-wrapper'},
    Content: {
        className: 'icon-wrapper',
        children: {
            icon: {
                className: 'icon',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/zIUVomgdcKEKcnnQdOzw.svg',
                name: '主要图标',
            },
            iconShadow: {
                className: 'icon-shadow',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/WIePwurYppfVvDNASZRN.svg',
                name: '图标影阴',
            },
            url: {children:headquarters, name: '跳转地址'},
            title: {children: '公司地址', name: '弹框标题'},
            content: {
                children: '江苏省南京市鼓楼区中山北路550号',
                name: '弹框内容',
            },
        },
    },
};
export const Contact01DataSource = {
    wrapper: {className: 'home-page-wrapper content11-wrapper'},
    Content: {
        className: 'icon-wrapper',
        children: {
            icon: {
                className: 'icon',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/zIUVomgdcKEKcnnQdOzw.svg',
                name: '主要图标',
            },
            iconShadow: {
                className: 'icon-shadow',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/WIePwurYppfVvDNASZRN.svg',
                name: '图标影阴',
            },
            url: {children: 'https://gaode.com/place/B0FFFE55JG', name: '跳转地址'},
            title: {children: '公司地址', name: '弹框标题'},
            content: {
                children: '江苏省南京市鼓楼区古平岗4号智梦园C座412',
                name: '弹框内容',
            },
        },
    },
};
export const Contact02DataSource = {
    wrapper: {className: 'home-page-wrapper content12-wrapper'},
    Content: {
        className: 'icon-wrapper',
        children: {
            icon: {
                className: 'icon',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/zIUVomgdcKEKcnnQdOzw.svg',
                name: '主要图标',
            },
            iconShadow: {
                className: 'icon-shadow',
                children:
                    'https://gw.alipayobjects.com/zos/rmsportal/WIePwurYppfVvDNASZRN.svg',
                name: '图标影阴',
            },
            url: {children: xining, name: '跳转地址'},
            title: {children: '公司地址', name: '弹框标题'},
            content: {
                children: '西宁市城东区共和路56号',
                name: '弹框内容',
            },
        },
    },
};
export const Banner30DataSource = {
    wrapper: {className: 'ContactUs_banner k0qcuji2xa8-editor_css'},
    textWrapper: {
        className: 'ContactUs_banner-text-wrapper k0qct9r6a-editor_css',
        children: [
            {
                name: 'nameEn',
                className: 'ContactUs_banner-name-en k0qcth162j-editor_css',
                children: (
                    <>
                        <p>Contact Us</p>
                    </>
                ),
            },
            {
                name: 'slogan',
                className: 'ContactUs_banner-slogan k0qcsufjqz-editor_css',
                children: '联系我们',
                texty: true,
            },

        ],
    },
};
